export const ASSIGNEE_UNASSIGNED = "__unassigned__";

function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function shortenId(value) {
  if (!isNonEmptyString(value)) return "Unbekannt";
  return value.trim().slice(0, 8);
}

export function getAssigneeLabel(user) {
  if (!user) return "Unbekannt";
  if (isNonEmptyString(user.full_name)) return user.full_name.trim();
  if (isNonEmptyString(user.email)) return user.email.trim();
  return shortenId(user.id);
}

export function getTaskAssigneeLabel({ assignedUserId, usersById }) {
  if (!assignedUserId) return "";
  const user = usersById ? usersById[assignedUserId] : null;
  if (!user) return "Unbekannt";
  return getAssigneeLabel(user) || "Unbekannt";
}

export function toAssignedUserId(value) {
  if (!value || value === ASSIGNEE_UNASSIGNED) return null;
  return value;
}

